module.exports = __webpack_public_path__ + "static/img/ercode.8d02932.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ercode.png
// module id = 0d5j
// module chunks = 2